import React, {useContext} from "react"
import {Box, Grid} from "@mui/material"
import {useLocation} from "react-router-dom"
import ButtonTemplate from "../../../anwendungskonfigurator/content/widgets/buttons/ButtonTemplate"
import {IconTypes} from '../../../akModel/mbk/mbk-definition'
import {ActionContext} from "../../context/ActionContextProvider"

const navigationPaths = Object.freeze({
    SUCHE: "/suche",
    JP_KUNDE_ANLEGEN: "/kunde/jp/:id",
    NP_KUNDE_ANLEGEN: "/kunde/np/:id",
    ANBAHNUNGSDATEN: "/anbahnung/:id",
    TARIFIERUNGSUEBERSICHT: "/anbahnung/:id/tarifierung",
    VERSICHERUNGSUMFANG: "/tarifierung/:id/versicherungsumfang",
    GRUPPENUNFALL: "/tarifierung/:id/gruppenunfalleinzel",
    GRUPPENUNFALLZUSAMMENFASSUNG: "/tarifierung/:id/gruppenunfalleinzel/zusammenfassung",
    RISIKOORTE: "/tarifierung/:id/risikoort",
    BEREICHE: "/tarifierung/:id/risikoort/bereich",
    KALKULATION: "/kalkulation/:id",
    BU: "/betriebsunterbrechungmv/:id",
})

const buttonActions = [
    {key: navigationPaths.SUCHE, value: [false, false, false]},
    {key: navigationPaths.JP_KUNDE_ANLEGEN, value: ['NAVIGIERE_BACK', false, false]},
    {key: navigationPaths.NP_KUNDE_ANLEGEN, value: ['NAVIGIERE_BACK', false, false]},
    {
        key: navigationPaths.ANBAHNUNGSDATEN,
        value: ['NAVIGIERE_BACK', 'ANBAHNUNG_SPEICHERN', 'WEITER_TARIFIERUNGSUEBERSICHT'],
    },
    {key: navigationPaths.TARIFIERUNGSUEBERSICHT, value: ['NAVIGIERE_BACK', false, false]},
    {key: navigationPaths.VERSICHERUNGSUMFANG, value: [false, 'VERSICHERUNGSUMFANG_SPEICHERN', 'WEITER_RISIKOORTE']},
    {key: navigationPaths.GRUPPENUNFALL, value: ["NAVIGIERE_BACK", 'GRUPPENUNFALL_SPEICHERN', 'GRUPPENUNFALL_WEITER']},
    {key: navigationPaths.GRUPPENUNFALLZUSAMMENFASSUNG, value: ["NAVIGIERE_BACK", false, false]},
    {key: navigationPaths.RISIKOORTE, value: ['NAVIGIERE_BACK', 'SAVE_RISIKOORT', 'WEITER_BEREICHE']},
    {key: navigationPaths.BEREICHE, value: ['NAVIGIERE_BACK', 'SAVE_BEREICH', 'WEITER_KALKULATION']},
    {key: navigationPaths.KALKULATION, value: ['NAVIGIERE_BACK', false, false]},
    {key: navigationPaths.BU, value: ['NAVIGIERE_BACK', false, 'UWP_WEITER']},
]

const matchesPathPattern = (path, pattern) => {
    let regexPattern = pattern.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    regexPattern = regexPattern.replace(/:([a-zA-Z0-9_]+)/g, '([^/]+)')
    const fullRegex = new RegExp(`^${regexPattern}$`)

    return fullRegex.test(path)
}

const FooterContainer = () => {
    const location = useLocation()
    const {triggerAction} = useContext(ActionContext)
    const path = Object.values(navigationPaths).find(entry => matchesPathPattern(location.pathname, entry))
    const actions = buttonActions.find(entry => path === entry.key)?.value ?? [false, false, false]

    if (!path) return null

    return (
        <Grid
            container
            height="62px"
            alignItems="center"
            width="100%"
            justifyContent="center"
            position="fixed"
            bottom={0}
            borderTop="1px #eeeeee solid"
            spacing={4}
            bgcolor="#FFFFFF"
        >
            {actions[0] ? (
                <ButtonTemplate
                    buttonText={"Zurück"}
                    variant="outlined"
                    startIcon={IconTypes.KEYBOARDDOUBLEARROWLEFTICON}
                    sx={{height: "42px", width: "20%"}}
                    actionType={actions[0]}
                    triggerAction={triggerAction}
                />
            ) : (
                <Box width="20%"/>
            )}
            {actions[1] ? (
                <ButtonTemplate
                    buttonText={"Speichern"}
                    variant="outlined"
                    startIcon={IconTypes.SAVEICON}
                    sx={{height: "42px", width: "20%"}}
                    actionType={actions[1]}
                    triggerAction={triggerAction}
                />
            ) : (
                <Box width="20%"/>
            )}
            {actions[2] ? (
                <ButtonTemplate
                    buttonText={"Weiter"}
                    variant="contained"
                    endIcon={IconTypes.KEYBOARDDOUBLEARROWRIGHTICON}
                    sx={{height: "42px", width: "20%"}}
                    actionType={actions[2]}
                    triggerAction={triggerAction}
                />
            ) : (
                <Box width="20%"/>
            )}
        </Grid>
    )
}

export default FooterContainer
